import AbstractRectangularTool from "./AbstractRectangularTool";

const CropTool = AbstractRectangularTool.extend({
  bindEvents(el, activate) {
    const selBtn = this.editor.getElement("crop-sel");
    selBtn.addEventListener("click", activate);

    this.editor.getElement("crop-do").addEventListener("click", () => { this.execute(); });
  },

  getUrl(x, y, w, h) {
    return `Act=crop&x=${x}&y=${y}&w=${w}&h=${h}`;
  },

  enter() {
    AbstractRectangularTool.prototype.enter.call(this);
    if(this.editor.opts.cropRatios) this.editor.setSelectionRatios(...this.editor.opts.cropRatios);
  },

  leave() {
    AbstractRectangularTool.prototype.leave.call(this);
    this.editor.setSelectionRatios(0, Infinity);
  }
});

export default CropTool;
